// src/pages/yachts/special-offers/IndexSpecialOffersContainer.js
import React from 'react';
import { connect } from 'react-redux';

import IndexSpecialOffersPresenter from './IndexSpecialOffersPresenter';
import {
    fetchInitSpecialOffers,
    fetchSpecialOffers,
    archiveSpecialOffer
} from './redux/_actions';

const ADMIN_ROLES = ['admin', 'admin_website', 'super_admin', 'owner'];

class IndexSpecialOffersContainer extends React.Component {
    state = { loading: true };

    componentDidMount() {
        const yachtId = this.props.match.params.id;
        this.props.fetchInitSpecialOffers();
        this.props
            .fetchSpecialOffers(yachtId)
            .then(() => this.setState({ loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    onCreate = () => {
        const id = this.props.match.params.id;
        this.props.history.push(
            `/yachts/edit/charter/${id}/special-offers/create`
        );
    };

    onEdit = (offerId) => {
        const id = this.props.match.params.id;
        this.props.history.push(
            `/yachts/edit/charter/${id}/special-offers/${offerId}/edit`
        );
    };

    onArchive = (offerId) =>
        this.props.archiveSpecialOffer(offerId).catch(() => {});

    render() {
        const is_admin = ADMIN_ROLES.includes(this.props.user_role);
        return (
            <IndexSpecialOffersPresenter
                loading={this.state.loading}
                offers={this.props.offers}
                user_role={this.props.user_role}
                is_admin={is_admin}
                match={this.props.match}
                history={this.props.history}
                onCreate={this.onCreate}
                onEdit={this.onEdit}
                onArchive={this.onArchive}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    user_role: state.auth.user_role,
    offers: state.yacht_special_offers.offers
});

const mapDispatchToProps = (dispatch) => ({
    fetchInitSpecialOffers: () => dispatch(fetchInitSpecialOffers()),
    fetchSpecialOffers: (yachtId) => dispatch(fetchSpecialOffers(yachtId)),
    archiveSpecialOffer: (id) => dispatch(archiveSpecialOffer(id))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IndexSpecialOffersContainer);
